<div class="asset-detail" [ngClass]="{'show': displayPdf}">
    <div class="page-wrapper pdf">
        <div class="row">
            <div class="col-12">
                <div class="icon-bar">
                    <button mat-icon-button (click)="close()"><mat-icon  fontIcon="close"></mat-icon></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                @if(pdfUrl) {
                    <div class="iframe-wrapper pdf" appFullHigh  bottomOffset=120>
                        <iframe [src]="pdfUrl | safe" width="100%" height="100%"></iframe>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
